module.exports = __webpack_public_path__ + "fa782a24a87f29e628d43686cdc7193c.svg";